import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class warranty_coverage extends entityBase {
  days_coverage: KnockoutObservable<number>;
  effective_dt: KnockoutObservable<Date>;
  formattedeffective_dt: any;
  end_dt: KnockoutObservable<Date>;
  formattedend_dt: any;
  months_coverage: KnockoutObservable<number>;
  wty_cov_type: KnockoutObservable<string>;
  wty_cov_id: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.days_coverage = ko.observable(item.days_coverage);
    this.effective_dt = ko.observable(this.formatJSONDate(item.effective_dt));
    this.formattedeffective_dt = CustomObservables.formattedDateObservable(this.effective_dt);
    this.end_dt = ko.observable(this.formatJSONDate(item.end_dt));
    this.formattedend_dt = CustomObservables.formattedDateObservable(this.end_dt);
    this.months_coverage = ko.observable(item.months_coverage);
    this.wty_cov_type = ko.observable(item.wty_cov_type).extend({ maxLength: 32 });
    this.wty_cov_id = ko.observable(item.wty_cov_id);
  }
}
